import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';

const tamanhoLoad = 40;

const StyledDialog = withStyles({
    root: {},
    paperWidthXs: {
        height: '80px',
        width: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'none',
        boxShadow: 'none'
    },
    paperWidthSm: {
        height: '80px',
        width: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'none',
        boxShadow: 'none'
    },
    paperWidthMd: {
        height: '80px',
        width: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'none',
        boxShadow: 'none'
    },
    paperWidthLg: {
        height: '80px',
        width: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'none',
        boxShadow: 'none'
    },
    paperWidthXl: {
        height: '80px',
        width: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'none',
        boxShadow: 'none'
    },
    paperFullWidth: {
        height: '80px',
        width: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'none',
        boxShadow: 'none'
    },
    paperFullScreen: {
        height: '80px',
        width: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'none',
        boxShadow: 'none'
    }
})(Dialog);

const Loading = ({ open }) => {
    return (
        <StyledDialog
            aria-labelledby='simple-dialog-title'
            open={open}
            disableBackdropClick
        >
            <CircularProgress size={tamanhoLoad} />
        </StyledDialog>
    );
};

Loading.propTypes = {
    open: PropTypes.bool.isRequired
};

export { Loading };
